<template>
  <van-popup
    v-model="showPopup"
    :close-on-click-overlay="closeOnClickOverlay"
  >
    <div class="common-popup">
      <slot />
      <img
        v-if="showCloseBtn"
        class="close-btn-image"
        src="@/assets/img/chargingVoucher/icon-close.png"
        @click="closePopup"
      >
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'CommonPopup',
  props: {
    showCloseBtn: {
      type: Boolean,
      default: false
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: false
    };
  },
  methods: {
    openPopup() {
      this.showPopup = true;
      this.$emit('open');
    },
    closePopup() {
      this.showPopup = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.common-popup {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 1200px;
  overflow: hidden;

  .close-btn-image {
    margin-top: 48px;
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
}
.van-popup {
  background-color: unset;
}
</style>
